<template>
  <modal
    ref="copyEnergetic"
    :ok-disabled="!$parent.to || loading || saving"
    ok-title="Presunúť"
    :title="`Presunúť odberné miesto: ${$parent.energetic.waterNumber}`"
    cancel-title="Zrušiť"
    full-height
    name="copy-energetic"
    scrollable
    size="lg"
    type="from-right"
    @hidden="$parent.reset"
    @ok="$parent.copyEnergetic"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <b-row>
              <b-col md="6">
                <select-picker
                  v-model="$parent.to"
                  label="name"
                  class="mb-3"
                  btn-class="m-0"
                  btn-variant="secondary"
                  fetch-url="customers/list"
                  placeholder="Vyberte zákazníka"
                >
                  <template #option="props">
                    {{ props.option.name }}
                  </template>
                </select-picker>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <h4>Technické údaje</h4>
                <b-form-group label="Číslo odberu" label-for="waterNumber">
                  <b-form-input
                    v-model="form.waterNumber"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('waterNumber') }"
                    data-vv-as="Číslo odberu"
                    name="waterNumber"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first('waterNumber') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  label="Číslo vodomeru (fakturačný / podružný)"
                  label-for="gaugeNumber"
                >
                  <b-form-input v-model="form.gaugeNumber" name="gaugeNumber" />
                </b-form-group>
                <b-form-group
                  label="Redukovaná plocha (m2)"
                  label-for="reducedArea"
                >
                  <vue-autonumeric
                    v-model="form.reducedArea"
                    class="form-control"
                    name="reducedArea"
                  />
                </b-form-group>
                <hr />
                <h4>Zmluvný vzťah</h4>
                <b-form-group
                  label="Výpoveď podáme za Vás"
                  label-for="cancellationID"
                >
                  <b-form-select
                    v-model="form.cancellationID"
                    :select-size="1"
                    name="cancellationID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.cancellation"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  label="Stav výpovede"
                  label-for="cancellationStateID"
                >
                  <b-form-select
                    v-model="form.cancellationStateID"
                    :select-size="1"
                    name="cancellationStateID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.cancellationState"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  label="Zmluva uzatvorená"
                  label-for="agreementTermID"
                >
                  <b-form-select
                    v-model="form.agreementTermID"
                    :select-size="1"
                    name="agreementTermID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.agreementTerm"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  label="Zmluva končí dňa"
                  label-for="agreementEndDate"
                >
                  <single-date
                    v-model="form.agreementEndDate"
                    class="form-control"
                    name="agreementEndDate"
                  />
                </b-form-group>
                <hr />
                <h4>Distribúcia</h4>
                <b-form-group
                  label="Dátum zač. odberu"
                  label-for="consumptionDateStart"
                >
                  <single-date
                    v-model="form.consumptionDateStart"
                    class="form-control"
                    name="consumptionDateStart"
                  />
                </b-form-group>
                <b-form-group
                  label="Spôsob evidencie"
                  label-for="evidenceTypeID"
                >
                  <b-form-select
                    v-model="form.evidenceTypeID"
                    :select-size="1"
                    name="evidenceTypeID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.evidenceType"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group label="Číslo OP" label-for="identityNumber">
                  <b-form-input
                    v-model="form.identityNumber"
                    name="identityNumber"
                  />
                </b-form-group>
                <b-form-group label="Číslo zmluvy" label-for="contractNumber">
                  <b-form-input
                    v-model="form.contractNumber"
                    name="contractNumber"
                  />
                </b-form-group>
                <b-form-group
                  label="Dátum konca odberu"
                  label-for="consumptionDateEnd"
                >
                  <single-date
                    v-model="form.consumptionDateEnd"
                    class="form-control"
                    name="consumptionDateEnd"
                  />
                </b-form-group>
                <b-form-group
                  label="Spôsob ukončenia"
                  label-for="endpointTypeID"
                >
                  <b-form-select
                    v-model="form.endpointTypeID"
                    :select-size="1"
                    name="endpointTypeID"
                  >
                    <option :value="null">--Nedefinované--</option>
                    <option
                      v-for="item in attributes.endpointType"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <h4>Adresa OM</h4>
                <b-form-group label="Ulica" label-for="street">
                  <b-form-input v-model="form.street" name="street" />
                </b-form-group>
                <b-form-group label="Číslo" label-for="streetNumber">
                  <b-form-input
                    v-model="form.streetNumber"
                    name="streetNumber"
                  />
                </b-form-group>
                <b-form-group label="Súp. číslo" label-for="streetRegNumber">
                  <b-form-input
                    v-model="form.streetRegNumber"
                    name="streetRegNumber"
                  />
                </b-form-group>
                <b-form-group label="Mesto" label-for="city">
                  <b-form-input v-model="form.city" name="city" />
                </b-form-group>
                <b-form-group label="PSČ" label-for="postCode">
                  <b-form-input v-model="form.postCode" name="postCode" />
                </b-form-group>
                <b-form-group label="Lokalita objektu" label-for="locality">
                  <b-form-input v-model="form.locality" name="locality" />
                </b-form-group>
                <b-form-group label="Názov objektu" label-for="localityName">
                  <b-form-input
                    v-model="form.localityName"
                    name="localityName"
                  />
                </b-form-group>
                <b-form-group label="Súradnice" label-for="coordinates">
                  <b-form-input v-model="form.coordinates" name="coordinates" />
                </b-form-group>
                <hr />
                <h4>Obchod</h4>
                <b-form-group
                  label="Dátum registrácie"
                  label-for="registrationDate"
                >
                  <single-date
                    v-model="form.registrationDate"
                    class="form-control"
                    name="registrationDate"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import SingleDate from '@/components/inputs/SingleDate'
import SelectPicker from '@/components/inputs/SelectPicker'

export default {
  components: {
    Modal,
    SingleDate,
    SelectPicker,
  },
  data() {
    return {
      loading: false,
      saving: false,
      attributes: [],
      form: {},
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      this.axios
        .all([
          this.$api.get('attributes/get', {
            params: {
              select: 'energetics',
              filter: { typeID: 1 },
            },
          }),
          this.$api.get(
            `energetics/${this.$route.params.energetics_id}/get_form`,
          ),
        ])
        .then(
          this.axios.spread((attrs, formdata) => {
            this.attributes = attrs.data
            this.form = Object.assign(formdata.data.data, {
              customer_id: null,
              id: null,
              consumptionDateStart: null,
              evidenceTypeID: null,
              identityNumber: null,
              contractNumber: null,
              consumptionDateEnd: null,
              endpointTypeID: null,
            })
            this.loading = false
          }),
        )
    },
  },
}
</script>
